import { useEffect, useRef } from 'react';

function FadeIn({ children, className = '', delay = 0 }) {
    const elementRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.style.animationDelay = `${delay}s`;
                        entry.target.classList.add('animate-fade-in');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (elementRef.current) {
            observer.observe(elementRef.current);
        }

        return () => observer.disconnect();
    }, [delay]);

    return (
        <div 
            ref={elementRef} 
            className={`opacity-0 translate-y-4 ${className}`}
        >
            {children}
        </div>
    );
}

export default FadeIn; 